import { call, put, all } from "redux-saga/effects";
import { reportError, reportSuccess } from "../actions/ErrorActions";
import { endLoading } from "../actions/LoadingActions";
import { reviewDecisionAPI } from "../api/ReviewDecisionCall";
import { startNextReview } from "../actions/NextReviewActions";

export function* reviewDecisionSaga(action) { 
    const result = yield call(reviewDecisionAPI, action);

    try {

        if (result.ok) {
            yield all([
                put(reportSuccess(`Review has been ${action.accepted}`)),
                put(startNextReview()),
                put(endLoading())
            ])
        } else {
            yield all([
                put(reportError("Unable to decide review")),
                put(endLoading())
            ]);
        }

    } catch(ex) {
        yield all([
            put(reportError("Unable to decide review")),
            put(endLoading())
        ]);
    }

}